import { Plus } from "lucide-react";
import { useMemo } from "react";

import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import type { TrackerType } from "@/components/tracker-view-modal";
import {
  BUILT_IN_TRACKERS,
  type CustomTrackerInfo,
  type TrackerCounts,
} from "@/features/spec-pilot/submittal/tracker-config";

interface TrackerMenuItemsProps {
  trackerCounts: TrackerCounts;
  customTrackers?: CustomTrackerInfo[];
  onAddToTracker: (type: TrackerType, customTrackerName?: string) => void;
  onCreateCustomTracker?: () => void;
}

export function TrackerMenuItems({
  trackerCounts,
  customTrackers = [],
  onAddToTracker,
  onCreateCustomTracker,
}: TrackerMenuItemsProps) {
  const uniqueCustomTrackers = useMemo(
    () =>
      Array.from(
        new Map(
          customTrackers.map((tracker) => [
            tracker.name.trim().toLowerCase(),
            tracker,
          ]),
        ).values(),
      ),
    [customTrackers],
  );

  return (
    <>
      {BUILT_IN_TRACKERS.map((tracker) => (
        <DropdownMenuItem
          key={tracker.type}
          onClick={() => onAddToTracker(tracker.type)}
        >
          {tracker.summaryLabel} ({trackerCounts[tracker.type]})
        </DropdownMenuItem>
      ))}

      {uniqueCustomTrackers.length > 0 ? <DropdownMenuSeparator /> : null}
      {uniqueCustomTrackers.map((tracker) => (
        <DropdownMenuItem
          key={tracker.name}
          onClick={() => onAddToTracker("custom", tracker.name)}
        >
          {tracker.name} ({tracker.count})
        </DropdownMenuItem>
      ))}

      {onCreateCustomTracker ? (
        <>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onSelect={(event) => {
              event.preventDefault();
              onCreateCustomTracker();
            }}
            className="font-medium text-primary"
          >
            <Plus className="mr-2 size-4" />
            Create Custom Tracker
          </DropdownMenuItem>
        </>
      ) : null}
    </>
  );
}
